/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AccessTokenType = {
    ClientCompany: 'CLIENT_COMPANY',
    Organization: 'ORGANIZATION',
    Account: 'ACCOUNT'
} as const;
export type AccessTokenType = typeof AccessTokenType[keyof typeof AccessTokenType];


export function instanceOfAccessTokenType(value: any): boolean {
    for (const key in AccessTokenType) {
        if (Object.prototype.hasOwnProperty.call(AccessTokenType, key)) {
            // @ts-ignore
            if (AccessTokenType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AccessTokenTypeFromJSON(json: any): AccessTokenType {
    return AccessTokenTypeFromJSONTyped(json, false);
}

export function AccessTokenTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessTokenType {
    return json as AccessTokenType;
}

export function AccessTokenTypeToJSON(value?: AccessTokenType | null): any {
    return value as any;
}

